import { render, staticRenderFns } from "./HeaderNotifications.vue?vue&type=template&id=0df06598&scoped=true"
import script from "./HeaderNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderNotifications.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderNotifications.vue?vue&type=style&index=0&id=0df06598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df06598",
  null
  
)

export default component.exports